<template>
  <div class="page-wrapper">
    <div style="width: 100%; height: 100%; display: flex;">
      <div style="width: 600px; height: 100%;">
        <div class="container">
          <div class="row">
            <div class="col-12 text-left" style="height:50px;line-height: 50px; font-size: 20px;font-weight: bold;">
<!--            </div>-->
<!--            <div class="col-8 text-right" style="height:50px;line-height: 50px;">-->
              <button class="btn btn-dark" v-on:click="selectMerchantByType('all')">All</button>
              <button class="btn btn-primary" v-on:click="selectMerchantByType('kokoro')">KOKORO</button>
              <button class="btn btn-danger" v-on:click="selectMerchantByType('jv')">JV</button>
              <button class="btn btn-success" v-on:click="selectMerchantByType('franchise')">Franchise</button>
              <button class="btn btn-primary" v-on:click="selectMerchantByType('premier')">Premier</button>
              <button class="btn btn-danger" v-on:click="selectMerchantByType('vendor')">Vendor</button>
              <button class="btn btn-success" v-on:click="selectMerchantByType('personal')">Personal</button>
            </div>
            <div class="col-12 text-left" style="padding-left: 60px;">
              Search <input v-model="merchantSearch" style="height: 30px; width: 200px;"/> <span v-on:click="merchantSearch = ''">Clear</span>
            </div>
          </div>
        </div>
        <div class="container" style="height: calc(100% - 50px); overflow-y: auto;">
          <div class="row">
            <div class="col-12">
              <transition-group name="list" tag="ul">
                <template v-for="m in merchants">
                <li class="list-group-item text-left hover-item"
                    :key="'candidate-' + m.id"
                    v-on:click="addMerchant(m)" v-if="isOnMerchantsList(m) == false && m.active === true && (merchantSearch.length === 0 || m.title.toLowerCase().includes(merchantSearch.toLowerCase()))">
                  [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}}
                </li>
                </template>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 500px; height: 100%;">
        <div style="height: 50px; line-height: 50px; width: 100%; padding-left: 10px;">
          <strong>HISTORY</strong> <date-picker v-model="dateRange"  valueType="format" @change="historyDateRangeSelected" range></date-picker> <button class="btn btn-success" style="margin-left:10px;" @click="getNoticeHistory">GET</button>
        </div>
        <div style="width: 100%; height: calc(100% - 50px); padding-left: 5px; padding-right: 5px; overflow-y: auto;">
          <ul class="list-group">
            <li v-for="item in historyItems" class="list-group-item" v-on:click="selectedItem = item">
              <div class="text-left"><strong>{{item.title}}</strong></div>
              <div class="text-right">{{convertTime(item.createdTimestamp)}}</div>
            </li>
          </ul>
        </div>

      </div>
      <div style="width: calc(100% - 1100px);  height: 100%; overflow-y: auto;">

        <div class="container text-left">
          <div class="row">
            <div class="col-12" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
              Notification Content
            </div>
          </div>

          <div class="row" style="margin-top:20px;">
            <div class="col-12">Title</div>
            <div class="col-12">
              <input v-model="notiTitle" class="form-control"/>
            </div>
          </div>

          <div class="row" style="margin-top:20px;">
            <div class="col-12">Body (Do not use special characters.)</div>
            <div class="col-12">
              <textarea v-model="notiContent" rows="5" class="form-control"/>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">Main content</div>
            <div class="col-12">

              <vue-editor v-model="notiMainContent"></vue-editor>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">Image Content (Click button below to add image)</div>
            <div class="col-12 text-left">
              <div v-if="notiImageUrl !== null && notiImageUrl.length > 0">
                <img :src="notiImageUrl" style="width: 100%;"/>
                <i class="fas fa-trash top-left-icon" v-on:click="notiImageUrl = ''"></i>
              </div>

              <div class="image-control">
                <progress value="0" max="100" id="uploader"></progress>
                <br>
                <input accept="image/*" type="file" ref="file" value="upload" @change="fileBtn"/>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top:20px;">
            <div class="col-12 text-right">
              <button class="btn btn-success" @click="submitNotice">SEND</button>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-6 text-left" style="height:50px;line-height: 50px; font-size: 20px;font-weight: bold;">
              Selected Shop List
            </div>
            <div class="col-6 text-right" style="height:50px;line-height: 50px;">
              <button class="btn btn-danger" v-on:click="selectedMerchants = []"><i class="fas fa-times" style="color:white;"></i> Clear</button>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div  style="border:1px solid gray; padding:10px; min-height: 300px;">
              <transition-group name="list" tag="ul">
                <li class="list-group-item text-left hover-item" v-for="(m, index) in selectedMerchants" :key="'selected-'+ m.id" v-on:click="selectedMerchants.splice(index, 1)">
                  [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}}
                </li>
              </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="manual-button" style="bottom: 20px; right: 40px; background: #000;" v-on:click="openHistoryView">-->
<!--      <i class="fas fa-history"></i>-->
<!--    </div>-->
    <transition name="slideup">
      <div class="item-container text-left" v-if="selectedItem != false" v-on:click="selectedItem = false">
        <div style="position: absolute; width: 1000px; height: 90%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">

          <div style="height: 100%; width: 100%; display: flex;">
            <div style="height: 100%; width: 400px; overflow-y: auto; padding:10px;" >
              <div style=" padding:10px;">Sent at {{convertTime(selectedItem.createdTimestamp)}}</div>
              <div style=" padding:10px;"><strong>{{selectedItem.title}}</strong></div>
              <div style="padding:10px; border: 1px solid gray; border-radius: 5px;">{{selectedItem.content}}</div>
            </div>
            <div style="height: 100%; width: calc(100% - 400px); overflow-y: auto;">


              <br>
              <div style="padding-left: 10px;">Received Merchants:</div>
              <div style="width: 100%; padding: 10px; display: inline-block;">
                <div v-for="m in selectedItem.list" class="notice-history-item" v-bind:class="{'notice-read':m.readTime > 0}">
                  <strong>{{m.merchant.title}}</strong> <span v-if="m.active === false"> (Inactive)</span>
                  <br>Notification Sent : {{convertTime(m.createdTimestamp)}}
                  <br><span v-if="m.readTime > 0" style="font-weight: bold;">Read at : {{convertTime(m.readTime)}}</span>
                  <span v-else style="font-weight: bold; color: red;">NOT READ YET</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
    import {getMerchants} from "../api/merchant";
    import {millisToDate, millisToReadable, setLastPage, showDialog} from "../api/utils";
    import {getNoticeHistory, registerNotices} from "../api/notice";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import {VueEditor} from 'vue2-editor';
    import moment from 'moment';
    import * as firebase from "firebase";
    export default {
      name: "Notifier",
      data() {
        return {
          merchants:[],
          selectedMerchants:[],
          notiTitle:'',
          notiContent:'',
          notiMainContent:'',
          notiImageUrl:'',
          historyView:false,
          dateRange:null,
          historyItems:[],
          selectedItem:false,
          merchantSearch:'',
        }
      },
      components: {
        DatePicker,
        VueEditor,
      },
      created() {
        setLastPage(this.$route.path);
        let today = new Date();

        let to = millisToDate(today.getTime(), '-');

        today.setDate(today.getDate()-30);
        let from = millisToDate(today.getTime(), '-');

        this.$data.dateRange = [from, to];
      },
      mounted() {
        this.getMerchantList();
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods: {
        dummy: function() {

        },
        convertTime: millisToReadable,
        getMerchantList: function() {
          let self = this;
          getMerchants()
            .then(function(data) {
              if(data.success == true) {
                let deactivatedList = [];
                for(let i = 0 ; i < data.item.length ; i++) {
                  if(data.item[i].active === true) {
                    self.$data.merchants.push(data.item[i]);
                  } else {
                    deactivatedList.push(data.item[i]);
                    console.log(data.item[i].title + ' is ' + data.item[i].active);
                  }
                }
                if(deactivatedList.length > 0) {
                  for(let i = 0 ; i < deactivatedList.length ; i++) {
                    self.$data.merchants.push(deactivatedList[i]);
                  }

                }
                self.getNoticeHistory();
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response !== undefined) {
                msg += ' (' + err.response + ')';
              }

              showDialog(msg, "Cannot get shop list");
            })
        },
        isOnMerchantsList: function(m) {
          for (let i = 0; i < this.$data.selectedMerchants.length; i++) {
            if(this.$data.selectedMerchants[i].id == m.id) {
              return true;
            }
          }
          return false;
        },
        selectMerchantByType: function(type) {
          // this.$data.statementMerchants = [];
          for (let i = 0; i < this.$data.merchants.length; i++) {
            if(type === 'all' || this.$data.merchants[i].type === type) {
              let foundFromSelectedList = false;
              for(let m = 0 ; m < this.$data.selectedMerchants.length ; m++) {
                if(this.$data.selectedMerchants[m].id == this.$data.merchants[i].id) {
                  foundFromSelectedList = true;
                  break;
                }
              }
              if(foundFromSelectedList == false) {
                this.$data.selectedMerchants.push(JSON.parse(JSON.stringify(this.$data.merchants[i])));
              }
            }
          }
          this.$data.selectedMerchants.sort(function(a, b) {
            return a.title > b.title ? 1 : -1;
          })
        },
        addMerchant: function(m) {
          let found = false;
          if(this.$data.selectedMerchants.length > 0) {
            for (let i = 0; i < this.$data.selectedMerchants.length; i++) {
              if(this.$data.selectedMerchants[i].id == m.id) {
                found = true;
                return;
              }
            }
          }
          this.$data.selectedMerchants.push(JSON.parse(JSON.stringify(m)));
          this.$data.selectedMerchants.sort(function(a, b) {
            return a.title > b.title ? 1 : -1;
          })

        },
        submitNotice: function() {
          if(this.$data.selectedMerchants === null || this.$data.selectedMerchants.length == 0) {
            showDialog("Please select shops to send notification to");
            return;
          }

          if(this.$data.notiTitle === null || this.$data.notiTitle.length === 0) {
            showDialog("Please enter title for push notification");
            return;
          }
          if(this.$data.notiContent === null || this.$data.notiContent.length === 0) {
            showDialog("Please enter message for push notification");
            return;
          }
          // if(this.$data.notiMainContent === null || this.$data.notiMainContent.length === 0) {
          //   showDialog("Please enter main message for notification");
          // }

          let items = [];
          let mainItem = {
            id:0,
            merchantId:0,
            title:this.$data.notiTitle,
            content: this.$data.notiContent,
            mainContent: this.$data.notiMainContent,
            imageUrl: this.$data.notiImageUrl,
          }
          items.push(mainItem);
          for(let i = 0 ; i < this.$data.selectedMerchants.length ; i++) {
            let item = {
              id:0,
              merchantId:this.$data.selectedMerchants[i].id,
              title:this.$data.notiTitle,
              content: this.$data.notiContent,
              mainContent: this.$data.notiMainContent,
              imageUrl: this.$data.notiImageUrl,
            }
            items.push(item);
          }

          let self = this;
          registerNotices(items)
          .then(function(data) {
            if(data.success === true) {
              self.$data.notiTitle = '';
              self.$data.notiContent = '';
              self.$data.notiMainContent = '';
              self.$data.notiImageUrl = "";
              showDialog("Sent successfully");
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg= err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }

            showDialog(msg, "Failed to send push notification");
          })
        },
        historyDateRangeSelected: function() {
          console.log("dateRangeSelected")
          console.log(this.$data.dateRange)

          if(this.$data.dateRange.length !== 2) {
            return;
          }

          if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
            let temp = this.$data.dateRange[1];
            this.$data.dateRange[0] = this.$data.dateRange[1];
            this.$data.dateRange[1] = temp;
          }

        },
        openHistoryView: function() {
          this.$data.historyView = {
            dateRange:null,
            list:[],
            selectedItem:false,
          }
        },
        getNoticeHistory: function() {


          if(this.$data.dateRange === null || this.$data.dateRange.length !== 2) {
            showDialog("Please select date range");
            return;
          }

          let start = new Date(this.$data.dateRange[0]);
          start.setHours(0,0,0,0);
          let end = new Date(this.$data.dateRange[1]);
          end.setHours(23,59,59,999);

          let self = this;
          this.$data.historyItems = [];

          getNoticeHistory(start.getTime(), end.getTime())
          .then(function(data) {
            if(data.success === true) {
              self.$data.historyItems = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }

            showDialog(msg, "ERROR");
          })

        },
        fileBtn:function(e) {
          // e.preventDefault();
          const uploader = document.getElementById('uploader');
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name = moment(d).format('YYYYMMDD-hhmmss');
          let yearMonthDay = moment(d).format('YYYY/MM/DD');
          let names = getFile.name.split('.');
          let path = 'notice/' + yearMonthDay + '/' + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
              self.$data.notiImageUrl = 'https://storage.googleapis.com/kokoro-294123.appspot.com/' + path;

            }
          );
        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Notifier.vue